/**
 * Custom map directive to be tweaked, twerked, and tickled
 * to show OUC-owned properties pulled in from the API
 *
 * @Properties: Properties = custom Angular factory
 * @attrs: map = string
 *
 */

google.maps.Map.prototype.panToWithOffset = function(latlng, offsetX, offsetY) {
    var map = this;
    var ov = new google.maps.OverlayView();
    ov.onAdd = function() {
        var proj = this.getProjection();
        var aPoint = proj.fromLatLngToContainerPixel(latlng);
        aPoint.x = aPoint.x+offsetX;
        aPoint.y = aPoint.y+offsetY;
        map.panTo(proj.fromContainerPixelToLatLng(aPoint));
    };
    ov.draw = function() {};
    ov.setMap(this);
};

ngOUC.directive('map', ['Properties', '$log', function (Properties, $log) {
    var link = function ($scope, element) {
        var mapLayers      = {},
            MAP_INIT_ZOOM  = 12,
            MAP_MIN_ZOOM   = 9,
            MAP_MAX_ZOOM   = 19,
            DEFAULT_LAT    = 28.538060,
            DEFAULT_LON    = -81.379749,
            htmlMap        = element[0],
            markerClusterer  = null,
            markers        = [],
            markersArray   = [];

        var STYLE_ARRAY = [
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers"    : [
                    {
                        "color": "#aad2e6"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry.fill",
                "stylers"    : [
                    {
                        "color": "#aedbab"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.fill",
                "stylers"    : [
                    {
                        "color": "#f0ede4"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "elementType": "geometry.fill",
                "stylers"    : [
                    {
                        "color": "#ebe6ea"
                    }
                ]
            },
            {
                "featureType": "road.highway.controlled_access",
                "elementType": "labels",
                "stylers"    : [
                    {
                        "saturation": 56
                    }
                ]
            }
        ];

        var STYLE_ARRAY = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];
        var STYLE_ARRAY = [{"featureType":"landscape","stylers":[{"hue":"#FFBB00"},{"saturation":43.400000000000006},{"lightness":37.599999999999994},{"gamma":1}]},{"featureType":"road.highway","stylers":[{"hue":"#FFC200"},{"saturation":-61.8},{"lightness":45.599999999999994},{"gamma":1}]},{"featureType":"road.arterial","stylers":[{"hue":"#FF0300"},{"saturation":-100},{"lightness":51.19999999999999},{"gamma":1}]},{"featureType":"road.local","stylers":[{"hue":"#FF0300"},{"saturation":-100},{"lightness":52},{"gamma":1}]},{"featureType":"water","stylers":[{"hue":"#0078FF"},{"saturation":-13.200000000000003},{"lightness":2.4000000000000057},{"gamma":1}]},{"featureType":"poi","stylers":[{"hue":"#00FF6A"},{"saturation":-1.0989010989011234},{"lightness":11.200000000000017},{"gamma":1}]}]

        // Build Info Window
        var infowindow = new google.maps.InfoWindow({});

        // Build map
        var map = new google.maps.Map(htmlMap, {
            center            : new google.maps.LatLng(DEFAULT_LAT, DEFAULT_LON),
            zoom              : MAP_INIT_ZOOM,
            maxZoom           : MAP_MAX_ZOOM,
            minZoom           : MAP_MIN_ZOOM,
            zoomControl       : ($(window).width() < 768 ? false : true),
            disableDefaultUI  : true,
            styles            : STYLE_ARRAY,
            zoomControlOptions: {
                style   : google.maps.ZoomControlStyle.SMALL,
                position: google.maps.ControlPosition.BOTTOM_LEFT
            },
        });

        $scope.removeLayers = function () {
            $log.debug('removeLayers()');

            angular.forEach(mapLayers, function (layer, layerName) {
                layer.setMap(null);
                delete mapLayers[layerName];
            });

            $('li.active').removeClass('active');
        };

        $scope.toggleIndustryLayer = function ($event, layerName) {
            $log.debug('toggleIndustryLayer() for ', layerName);

            if (layerName in mapLayers) {
                // If this layer is already on the screen, remove it and delete it
                removeLayerFromMap(layerName);

                angular.element($event.currentTarget).removeClass('active');
            } else {
                // Otherwise add it
                addLayerToMap(layerName);

                angular.element($event.currentTarget).addClass('active');
            }

            $scope.styleMenus();
        };

        var lastDemographicLayer;
        var lastDemographicTarget;

        $scope.toggleDemographicLayer = function ($event, layerName) {
            $log.debug('toggleDemographicLayer() for ', layerName);

            $('.legend').hide();

            if (layerName in mapLayers) {
                removeLayerFromMap(layerName);
                angular.element($event.currentTarget).removeClass('active');
            } else {
                if (lastDemographicLayer in mapLayers) {
                    removeLayerFromMap(lastDemographicLayer);
                    angular.element(lastDemographicTarget).removeClass('active');
                }

                addLayerToMap(layerName);
                angular.element($event.currentTarget).addClass('active');

                $('.legend#' + layerName).show();
            }

            lastDemographicLayer  = layerName;
            lastDemographicTarget = $event.currentTarget;

            $scope.styleMenus();
        };

        function removeLayerFromMap(layerName) {
            mapLayers[layerName].setMap(null);

            infowindow.close();

            delete mapLayers[layerName];
        };

        function addLayerToMap(layerName) {
            // Make a new KML layer from a remote data source

            mapLayers[layerName] = new google.maps.KmlLayer({
                map                : map,
                url                : 'http://oucpowersgrowth.com/wp-content/themes/oucecon/map/kml/compressed/' + layerName + '.kmz?' + Math.random(),
                preserveViewport   : true,
                suppressInfoWindows: true,
                zIndex             : 
                layerName == 'WaterCoverage_v2' ? 100 : 
                layerName == 'ElectricCoverage_v2' ? 110 : 
                layerName == 'Orange_County_Outline' ? 120 :  
                layerName == 'Osceola_County_Outline' ? 130 : 
                layerName == 'OrlandoCityLimitsBoundary' ? 140 : 
                layerName == 'StCloudCityBoundary' ? 150 : 
                160,
            });

            // The data provided in the description for the infoWindow isn't ideal, so we suppressInfoWindows when
            // we created the layer (above), and now we're going to roll our own infoWindow manager
            google.maps.event.addListener(mapLayers[layerName], 'click', function (kmlEvent) {
                // Close the infowindow if it is open
                infowindow.close();

                // Create or redefine the infowindow
                infowindow = new google.maps.InfoWindow({
                    position   : kmlEvent.latLng,
                    pixelOffset: new google.maps.Size(0, -5),
                });

                // infoWindowContents is the new content to use. For now, we just want to remove images from it
                infoWindowContents = '<b>' + kmlEvent.featureData.name + '</b><br>' + kmlEvent.featureData.description.replace(/<img[^>]*>/g, "");

                // Set the contents
                infowindow.setContent(infoWindowContents);

                // Open the infoWindow
                infowindow.open(map);
            });
        }

        $scope.highlightProperty = function (id, cluster) {
            if((/\/$/).test(id)){
                id = id.slice(0, -1);
            }
            $log.debug('highlightProperty firing for property', id);

            map.panToWithOffset(markersArray[id].getPosition(), 0, 0);

            $scope.seeProperty(id);

            var selectString = '';
            if (cluster) { 
                var markers = cluster.getMarkers();

                // Do the code for a dropdown box here 
                // for(var i = 0; i < markers.length; i++) {
                //     // id = markers[i].getTitle();
                //     // name = markersArray[id].name;
                // }
            }

            var sizeString = '';
            if( (markersArray[id].sizeMin.length != 0 && markersArray[id].sizeMax.length != 0) && markersArray[id].sizeMin != markersArray[id].sizeMax){
                sizeString += '<p><span>' + markersArray[id].sizeMin;
                if ( (markersArray[id].sizeMinUnit.length != 0 && markersArray[id].sizeMaxUnit.length != 0) && markersArray[id].sizeMinUnit != markersArray[id].sizeMaxUnit){
                    sizeString += ' ' + markersArray[id].sizeMinUnit;
                }
                sizeString += ' - ' + markersArray[id].sizeMax + ' ' + markersArray[id].sizeMaxUnit + ' available</span></p>';
            }else if(markersArray[id].sizeTotal != undefined && markersArray[id].sizeTotal.length != 0 ) {
                sizeString += '<p><span>' + markersArray[id].sizeTotal + ' total ' + markersArray[id].sizeTotalUnit + ' available</span></p>';
            }else if(markersArray[id].sizeMin === markersArray[id].sizeMax && markersArray[id].sizeMin != 0){
                sizeString += '<p><span>' + markersArray[id].sizeMin + ' equal ' + markersArray[id].sizeMinUnit + ' available</span></p>';
            }

            infowindow.setContent('<div class="property-modal" id="iw-container ">' + selectString +
                                  '     <div class="picture" style="background-image: url(\'' + markersArray[id].image + '\')"></div>' +
                                  '     <p class="name">' + markersArray[id].name + '</p>' +
                                  '     <p>' + markersArray[id].address + '</p>' +
                                  '     <p class="city-state-zip">' + markersArray[id].city + ', ' + markersArray[id].state + ' ' + markersArray[id].zip + '</p><hr>' +
                                       (markersArray[id].buildingType.length != 0
                                           ? '<p><span>Building Class ' + markersArray[id].buildingType +'</span></p>'
                                           : '' ) + sizeString +
                                  '    <a class="property-link btn teal" data-id="' + id + '">See Property</a>' +
                                  '</div>');

            if (cluster) {
                var center = new google.maps.LatLng(cluster.center_.lat(),cluster.center_.lng());
                infowindow.setPosition(center);
                infowindow.open(map);
            } else {
                infowindow.open(map, markersArray[id]);
            }
        };

        $(document).on('click', '.property-link', function () {
            $scope.focus('property');
            $scope.seeProperty($(this).data('id'));
        });

        // Drop all those markers, bruh bruh bruh bruh bruh bruh bruh bruh bruh
        $scope.$parent.updateMap = function () {
            
            $log.debug('Map.updateMap()');

            angular.forEach(markers, function (value, key) {
                markers[key].setMap(null);
            });

            // Clear all marker clusters
            if (markerClusterer) {
                markerClusterer.clearMarkers();
            }

            markers = [];

            map.panToWithOffset(new google.maps.LatLng(DEFAULT_LAT, DEFAULT_LON), 0, 0);

            angular.forEach($scope.properties, function (value) {
                var latlon    = new google.maps.LatLng(value.lat, value.lon),
                    mapMarker = new google.maps.Marker({
                        position    : latlon,
                        map         : map,
                        title       : String(value.id),
                        image       : String(value.image1),
                        name        : String(value.name),
                        address     : String(value.address1),
                        city        : String(value.city),
                        state       : String(value.state),
                        zip         : String(value.zip),
                        buildingType: String(value.buildingtypes),
                        sizeMin     : String(value.siteSmallestSpace).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
                        sizeMinUnit : String(value.siteSmallestSpaceUnit).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
                        sizeMax     : String(value.siteLargestSpace).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
                        sizeMaxUnit : String(value.siteLargestSpaceUnit).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
                        sizeTotal   : String(value.siteTotalSpace).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
                        sizeTotalUnit: String(value.siteTotalSpaceUnit).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
                        icon        : OucGlobals.mediaDirectory + '/img/pin2.png'
                    });

                markers.push(mapMarker);

                markersArray[value.id] = mapMarker;

                google.maps.event.addListener(mapMarker, 'click', function () {
                    $scope.highlightProperty(mapMarker.title);
                });
           });

            // ======= Marker Clustering =======
            markerClusterer = new MarkerClusterer(map, markers, {imagePath: OucGlobals.mediaDirectory + '/img/m'});

            // Limit the zoom level
            google.maps.event.addListener(map, 'zoom_changed', function() {
                if (map.getZoom() < MAP_MIN_ZOOM) {
                    map.setZoom(MAP_MIN_ZOOM);
                }
                if (map.getZoom() > MAP_MAX_ZOOM) {
                    google.maps.event.addListenerOnce(map, 'bounds_changed', function() {
                        map.setZoom(MAP_MAX_ZOOM);
                    });
                }
            });                

            // Add listener to the cluster
            google.maps.event.addListener(markerClusterer, 'clusterclick', function(cluster) {
                if (map.getZoom() >= MAP_MAX_ZOOM) {
                    $scope.highlightProperty(cluster.getMarkers()[0].getTitle(), cluster);
                }
            });

            $scope.mapUpdated();
        };
    };

    return {
        restrict: 'A',
        link    : link
    };
}]);
